import React, { Component } from "react";
// import imgCongr from './images/icons/tick1.png';



class HeaderIntroduction extends Component {
      constructor(props) {
        super(props);  
        this.state = {
            offsetWidth : 0,
        }
    }
  //   updateDimensions = () => {
  //     var width = document.getElementById('acorn-body');
  //     this.setState({ deviceWidth: width.offsetWidth });   
  // };
    componentDidMount() {
      // window.addEventListener('resize', this.updateDimensions);
      var that = this;
      // window.addEventListener("resize", (ev) => {
      //     var width = document.getElementById('acorn-body');
      //     that.setState({ deviceWidth : width.offsetWidth});
      // });
  }
  // componentWillUnmount() {
  //     window.removeEventListener('resize', this.updateDimensions);
  // }
//   GenerateApplyLink() {
//     let lenderApplyLink = `${this.props.applyLink}`;        
//     if(this.props.dealerid || window[this.props.rootId].dealerId) {
//         // Unset the previous link //
//         lenderApplyLink="";
//         let delearID=this.props.dealerid?this.props.dealerid:( window[this.props.rootId].dealerId?window[this.props.rootId].dealerId:'');
//         lenderApplyLink = window.applicationURL+`${lenderApplyLink}?d=${delearID}`;
//         lenderApplyLink+=`&cta=lenderList`;
//     }else{
//         lenderApplyLink="";
//         lenderApplyLink = window.applicationURL;
//         lenderApplyLink+='?cta=lenderList';  
//     }
//     // lenderApplyLink = lenderApplyLink.replace('[clickid]', this.state.mpUniqueClickID).replace('[affiliateid]',this.props.AffiliateId);
//     return  lenderApplyLink;
// }
    render() {
        const ctaText = 'GET STARTED';
        // const applyLink = this.props.ctaBtnLink;
        return (
          this.props.deviceWidth >= 768 && this.props.getStartedlink !== "" && this.props.getStartedLink.length > 0 && 
            <div className="row col-lg-12 col-md-12 contentBackground">
              <div className={`col-lg-9 col-md-9 col-sm-9 col-xs-9 alignContent `}>
                <h3 className="HeaderText">Check your personal loan rates</h3>
                <p className="subHeader">See which loans you pre-qualify for without impacting your credit score. Simply answer a few
                  questions to get estimates from top national lenders.</p>
              </div>              
                <div className={`col-lg-3 col-md-3 col-sm-3 col-xs-3 lenderinfoV2 lender-listing cta-btn`}>
                  <a href={this.props.getStartedLink}><b className={`cta-button desktop`}>{ctaText}</b></a> </div>
      </div> 
        );
    }
}
export default HeaderIntroduction;


// WEBPACK FOOTER //
// ./src/HeaderIntroduction.js